import "react-calendar/dist/Calendar.css";

import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { Field, Form, Formik } from "formik";
import * as Yup from "yup";

import { axiosInstance } from "api/axios";
import { REGISTER_URL } from "api/Service";
import regImg from "assets/images/signup-authentication-bg.jpg";
import { ProgressStep } from "components/ProgressStep";
import { pathGenerators } from "utils/routes";

const phoneRegExp =
  /^((\\+[1-9]{1,4}[ \\-]*)|(\\([0-9]{2,3}\\)[ \\-]*)|([0-9]{2,4})[ \\-]*)*?[0-9]{3,4}?[ \\-]*[0-9]{3,4}?$/;

const validationSchema = Yup.object().shape({
  firstname: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("This field is required"),
  lastname: Yup.string()
    .min(2, "Too Short!")
    .max(50, "Too Long!")
    .required("This field is required"),
  address: Yup.string().required("This field is required"),
  address2: Yup.string().required("This field is required"),
  county: Yup.string(),
  tandc: Yup.boolean().oneOf([true], "You must accept"),
  country: Yup.string().required("This field is required"),
  mobileNum: Yup.string()
    .matches(phoneRegExp, "Phone number is not valid")
    .required("Mobile number is required"),
  email: Yup.string()
    .email("Must be a valid email")
    .max(255)
    .required("Email is required"),
  password: Yup.string()
    .max(255)
    .min(6, "Password must be at least 6 characters long")
    .required("Password is required"),
  passwordConfirmation: Yup.string().oneOf(
    [Yup.ref("password"), null],
    "Passwords must match"
  ),
});

const SignUpPage = () => {
  const navigate = useNavigate();
  const initialValues = {
    email: "",
    firstname: "",
    lastname: "",
    mobileNum: "",
    password: "",
    tandc: false,
    address: "",
    address2: "",
    town: "",
    city: "",
    country: "",
    eircode: "",
    passwordConfirmation: "",
  };

  const [value, setValue] = useState();

  const handleSubmit = async (values, { setSubmitting, resetForm }) => {
    try {
      const { email, password, firstname, lastname, mobile } = values;
      await axiosInstance.post(
        REGISTER_URL,
        {
          email,
          password,
          firstname,
          lastname,
          mobile,
        },
        {
          headers: {
            "Content-Type": "application/json",
            "Access-Control-Allow-Origin": "*",
          },
        }
      );
      resetForm();
      navigate(pathGenerators.auth.signupTwo());
    } catch (err) {
      console.error(err);
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <>
      <section className="signup_section">
        <div className="container containarwhite">
          <div className="row">
            <ProgressStep activeStep={1} />
            <div className="col-md-12">
              <h2 className="d_name mb38">Kinesin Health</h2>
            </div>
            <div className="col-md-6 ">
              <div className="log_wrap">
                <Formik
                  initialValues={initialValues}
                  onSubmit={handleSubmit}
                  validationSchema={validationSchema}
                >
                  {({ errors, touched, isSubmitting }) => (
                    <Form>
                      <p className="head_para">MyDetails</p>

                      <div className="form-floating mb-3">
                        <Field
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Email"
                          id="floatingInput9"
                        />
                        <label htmlFor="floatingInput9">Email</label>
                        {errors.email && touched.email && (
                          <div className="errorstext">{errors.email}</div>
                        )}
                      </div>

                      <div className="form-floating mb-3">
                        <Field
                          type="text"
                          name="firstname"
                          className="form-control"
                          placeholder="Firstname"
                          id="floatingInput6"
                        />
                        <label htmlFor="floatingInput9">Firstname</label>
                        {errors.firstname && touched.firstname && (
                          <div className="errorstext">{errors.firstname}</div>
                        )}
                      </div>

                      <div className="form-floating mb-3">
                        <Field
                          type="text"
                          name="lastname"
                          className="form-control"
                          placeholder="Lastname"
                          id="floatingInput7"
                        />
                        <label htmlFor="floatingInput9">Lastname</label>
                        {errors.lastname && touched.lastname && (
                          <div className="errorstext">{errors.lastname}</div>
                        )}
                      </div>

                      <div className="form-floating mb-3">
                        <LocalizationProvider dateAdapter={AdapterDayjs}>
                          <DemoContainer
                            components={["DatePicker", "DatePicker"]}
                          >
                            <DatePicker
                              format="DD-MM-YYYY"
                              label="DOB"
                              value={value}
                              sx={{ width: "100%" }}
                              onChange={(newValue) => {
                                setValue(newValue);
                              }}
                            />
                          </DemoContainer>
                        </LocalizationProvider>
                      </div>

                      <p className="head_para">Address</p>

                      <div className="form-floating mb-3">
                        <Field
                          type="text"
                          name="address"
                          className="form-control"
                          placeholder="First Line"
                          id="floatingInput4"
                        />
                        <label htmlFor="floatingInput4">Address 1</label>
                        {errors.address && touched.address && (
                          <div className="errorstext">{errors.address}</div>
                        )}
                      </div>

                      <div className="form-floating mb-3">
                        <Field
                          type="text"
                          name="address2"
                          className="form-control"
                          placeholder="Second Line"
                          id="floatingInput5"
                        />
                        <label htmlFor="floatingInput5">Address 2</label>
                        {errors.address2 && touched.address2 && (
                          <div className="errorstext">{errors.address2}</div>
                        )}
                      </div>

                      <div className="form-floating mb-3">
                        <Field
                          type="text"
                          name="town"
                          className="form-control"
                          placeholder="Town"
                          id="floatingInput5"
                        />
                        <label htmlFor="floatingInput5">Town</label>
                        {errors.town && (

                          <div className="errorstext">{errors.town}</div>
                        )}
                      </div>

                      <div className="form-floating mb-3">
                        <Field
                          type="text"
                          name="city"
                          className="form-control"
                          placeholder="City"
                          id="floatingInput5"
                        />
                        <label htmlFor="floatingInput5">City</label>
                        {errors.city && (

                          <div className="errorstext">{errors.city}</div>
                        )}
                      </div>

                      <div className="form-floating mb-3">
                        <Field
                          type="text"
                          name="county"
                          className="form-control"
                          placeholder="County"
                          id="floatingInput5"
                        />
                        <label htmlFor="floatingInput5">County</label>
                        {errors.county && (

                          <div className="errorstext">{errors.county}</div>
                        )}
                      </div>

                      <div className="form-floating mb-3">
                        <Field
                          type="text"
                          name="country"
                          className="form-control"
                          placeholder="Country"
                          id="floatingInput6"
                        />
                        <label htmlFor="floatingInput6">Country</label>
                        {errors.country && touched.country && (
                          <div className="errorstext">{errors.country}</div>
                        )}
                      </div>

                      <div className="form-floating mb-3">
                        <Field
                          type="text"
                          name="eircode"
                          className="form-control"
                          placeholder="Eircode"
                          id="floatingInput7"
                        />
                        <label htmlFor="floatingInput7">Eircode</label>
                        {errors.eircode && (

                          <div className="errorstext">{errors.eircode}</div>
                        )}
                      </div>

                      <div className="form-floating mb-3 mobile-input">
                        <Field
                          type="tel"
                          name="mobileNum"
                          className="form-control"
                          placeholder="+44 0203 0484377"
                          id="floatingInput7"
                        />
                        <label htmlFor="floatingInput9">Mobile Number</label>
                        {errors.mobileNum && touched.mobileNum && (
                          <div className="errorstext">{errors.mobileNum}</div>
                        )}
                      </div>

                      <div className="form-floating mb38">
                        <div className="form-group">
                          <label className="agree_check">
                            <Field type="checkbox" name="tandc" />
                            <span className="checkmark"></span>
                            <span className="agree_check_txt">
                              Consent to receive text messages
                            </span>
                          </label>
                          {errors.tandc && touched.tandc && (
                            <div className="errorstext">{errors.tandc}</div>
                          )}
                        </div>
                      </div>

                      <p className="head_para">MyAccount</p>
                      <div className="form-floating mb-3">
                        <Field
                          type="email"
                          name="email"
                          className="form-control"
                          placeholder="Email"
                          id="floatingInput9"
                        />
                        <label htmlFor="floatingInput9">Email</label>
                        {errors.email && touched.email && (
                          <div className="errorstext">{errors.email}</div>
                        )}
                      </div>

                      <div className="form-floating mb-3">
                        <Field
                          type="password"
                          name="password"
                          className="form-control"
                          placeholder="Password"
                          id="floatingInput10"
                        />
                        <label htmlFor="floatingInput10">Password</label>
                        {errors.password && touched.password && (
                          <div className="errorstext">{errors.password}</div>
                        )}
                      </div>

                      <div className="form-floating mb38">
                        <Field
                          type="password"
                          name="passwordConfirmation"
                          className="form-control"
                          placeholder="Confirm password"
                          id="floatingInput11"
                        />

                        <label htmlFor="floatingInput11">
                          Confirm password
                        </label>
                        {errors.passwordConfirmation &&
                          touched.passwordConfirmation && (
                            <div className="errorstext">
                              {errors.passwordConfirmation}
                            </div>
                          )}
                      </div>

                      <div className="btnxscenter">
                        <button
                          className="custom_btn login_btn"
                          type="submit"
                          disabled={isSubmitting}
                        >
                          Register
                        </button>
                      </div>

                    </Form>
                  )}
                </Formik>
              </div>
            </div>
            <div className="col-md-6 preletiv">
              <div className="signup-authimg-wrapper">
                <img src={regImg} className="regImg2" alt="" />
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export { SignUpPage };